<template>
    <div class="animated">
        <v-client-table :columns="columns" :data="results" :options="options" :theme="theme" id="customer-table" class="w-100">
            <span slot="customer" slot-scope="{row}">
                <router-link :to="'/customer/'+row.result_events[0].laboratory_client.customer_id">{{row.result_events[0].laboratory_client.business}}</router-link>
            </span>
            <span slot="actions" slot-scope="{row}">
              <b-button variant="info" class="px-1 py-0 mr-1 text-white" v-on:click="downloadXml(row.id)">
                <i class="fa fa-download"></i>
              </b-button>
            </span>
        </v-client-table>
    </div>
</template>

<script>
  import Vue from 'vue';
  import {ClientTable, Event} from 'vue-tables-2';

  Vue.use(ClientTable);

  export default {
    name: 'ResultTable',
    components: {
      ClientTable,
      Event
    },
    props: ['results'],
    data: function () {
      return {
        columns: [
          'customer',
          'grower',
          'field',
          'type',
          'received_at',
          'actions'
        ],
        data: this.results,
        options: {
          headings: {
            'customer': 'Customer Name',
            'received_at': 'Date/Time',
            'result_type': 'Type'
          },
          sortable: [
            'customer',
            'grower',
            'field',
            'type',
            'received_at',
          ],
          filterable: [
            'customer',
            'grower',
            'field',
            'type',
            'received_at',
          ],
          sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default'
      }
    },
    methods: {}
  };
</script>
